import baseAPI from '@/api';
import { User } from '@/models/user';

export async function fetchUserProfile() {
  const response = await baseAPI.get<User>('users/me');
  const user = response.data;
  return user;
}
